import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

type Props = { smooth?: boolean; skipForModalStateKey?: string };

export default function ScrollToTop({ smooth = true, skipForModalStateKey }: Props) {
  const location = useLocation();
  const action = useNavigationType(); // "PUSH" | "REPLACE" | "POP"

  useEffect(() => {
    // If you open modal routes and want to keep scroll, honor a flag in state
    if (skipForModalStateKey && (location.state as any)?.[skipForModalStateKey]) return;

    // Keep scroll position when user navigates with Back/Forward (POP)
    if (action === "POP") return;

    // If there’s a hash, try to scroll to that element; otherwise top
    if (location.hash) {
      const el = document.getElementById(location.hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: smooth ? "smooth" : "auto", block: "start" });
        return;
      }
    }

    window.scrollTo({ top: 0, left: 0, behavior: smooth ? "smooth" : "auto" });
  }, [location.pathname, location.search, location.hash, action, skipForModalStateKey, smooth]);

  return null;
}
